import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";

function OneWithoutNavLnk({colorIcon, title, icon, langLocal, arrow, items }) {
    const [activeArrow, setactiveArrow] = useState(false)
    const colors=[
        '--pink','--green','--purpule','--blue','--yellow'
    ]
    return (
        <>
            <div className={`linkk ${activeArrow ? "active_menu_link" : ""} `} onClick={() => { if (arrow) setactiveArrow(!activeArrow) }}>
                <div dir={langLocal == "ar" ? "rtl" : "ltr"} className={`sidebar_link `}>
                    <div>
                        <i  style={{color: `var(${colorIcon})`}} className={icon}></i>
                        <span> {title} </span>
                    </div>
                    {
                        arrow && (
                            <i style={{color: `var(${colorIcon})`}} className={activeArrow ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} ></i>
                        )
                    }

                </div>
            </div>
            {
                activeArrow && (
                    <div className='items' dir={langLocal == "ar" ? "rtl" : "ltr"} >
                        {
                            items && (
                                items.map((item) => {
                                    return (
                                        <Link to={item.url}>
                                            <i style={{color: `var(${colorIcon})`}} className={`${item.icon} ${langLocal === 'ar' ? "margin_left_20" : "margin_right_20"}`} ></i>
                                            <p className={langLocal === 'ar' ? "margin_left_20" : "margin_right_20"}>{item.title}</p>
                                        </Link>
                                    )
                                })
                            )
                        }

                    </div>
                )
            }
        </>
    )
}

export default OneWithoutNavLnk